import axios from "axios";

import { baseAxios } from "config";

const savePayrollBatchRow = async ({ eventUrl, jobSlug, data }) => {
  const res = await baseAxios.post(
    `${jobSlug ? `/payroll/job/${jobSlug}` : `/payroll/event/url/${eventUrl}`}/save/payroll`,
    data
  );
  return res;
};

export default savePayrollBatchRow;
